import React from "react";
import { Plus } from "lucide-react";

const styles = `
  fieldset {
  padding:20px 20px 20px 20px;
  margin-bottom:10px;
  border:1px solid #1E96C8;
  }
  legend {
  color: #1E96C8;
  font-weight:bold
  }

`;

function ConnectionItem({ label, count, navigate, path }) {
  return (
    <div className="connection-item">
      <button className="connection-btn" onClick={()=>{navigate(path)}}>
        {count !== undefined && (
          <span className="connection-count">{count}</span>
        )}
        {label}
      </button>
      <button className="connection-add-btn" onClick={()=>{navigate(path + '/form')}}>
        <Plus size={16} />
      </button>
    </div>
  );
}
// CSS Style component
const FormStyles = () => <style>{styles}</style>;

export function ConnectionGroup({ title, items, navigate, path }) {
  return (
    <>
      <FormStyles />
      <fieldset>
        <legend>{title}</legend>
        <div className="connection-group">
          <div className="connection-items">
            {items.map((item, index) => (
              <ConnectionItem
                key={index}
                label={item.label}
                count={item.count}
                path={item.path}
                navigate={navigate}
              />
            ))}
          </div>
        </div>
      </fieldset>
    </>
  );
}
